import React , { useState }  from "react";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function InputSciancratura(props) {
        
    //const prodottoTemp=props.prodottoTemp;
    const inputLabel=props.inputLabel;
    const datoName=props.datoName;
    const datoId=props.datoId;
    const datoValue=props.datoValue;
    const datoPlaceHolder=props.datoPlaceHolder;
    const datoOnChange= props.datoOnChange;
    const datoClass= props.datoClass;
    const classiTastoSblocco = props.classiTastoSblocco;
    const tastoCopiaAspetto = props.tastoCopiaAspetto;
    const handleChangeSciancratura = props.handleChangeSciancratura;

    const {
        classeDatiPiccoli,
        buttonClassesWhite
    } = stilePulsanti
    
    const [punta, setPunta] = useState("")
    const [centro, setCentro] = useState("")
    const [coda, setCoda] = useState("")
    const [misura, setMisura] = useState("")
    
    function handleChangePunta(evt) {
        setPunta(evt.target.value);
    }

    function handleChangeCentro(evt) {
        setCentro(evt.target.value);
    }

    function handleChangeCoda(evt) {
        setCoda(evt.target.value);
    }

    function handleChangeMisura(evt) {
        setMisura(evt.target.value);
    }

    function impostaSciancratura(evt) {
        handleChangeSciancratura(punta,centro,coda,misura)
    }
    
    
    return (
        <div className="mb1">
            <label for={datoId}
                className="pointer" 
                onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
            >{inputLabel}</label><br />
                        <span>P</span>
                        <input
                            type="number"
                            id="punta"
                            placeholder="punta"
                            name="punta"
                            value={punta}
                            autoComplete="off"
                            onChange={handleChangePunta}
                            className={classeDatiPiccoli}
                        />
                        <span>C</span>
                        <input
                            type="number"
                            id="centro"
                            placeholder="centro"
                            name="centro"
                            value={centro}
                            autoComplete="off"
                            onChange={handleChangeCentro}
                            className={classeDatiPiccoli}
                        />
                        <span>C</span>
                        <input
                            type="number"
                            id="coda"
                            placeholder="coda"
                            name="coda"
                            value={coda}
                            autoComplete="off"
                            onChange={handleChangeCoda}
                            className={classeDatiPiccoli}
                        />
                        <br />
                        <span>@</span>
                        <input
                            type="number"
                            id="misura"
                            placeholder="misura"
                            name="misura"
                            value={misura}
                            autoComplete="off"
                            onChange={handleChangeMisura}
                            className={classeDatiPiccoli}
                        />
                        <button onClick={impostaSciancratura} className={buttonClassesWhite}>imposta</button>
                        <br />
                        <input
                            type="text"
                            id={datoId}
                            placeholder={datoPlaceHolder}
                            name={datoName}
                            value={datoValue}
                            autoComplete="off"
                            onChange={datoOnChange}
                            className={datoClass}
                        />                        
            <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button><br />  
        </div>
    )



}

export default InputSciancratura;